'use client'

import type { ComponentProps, MouseEvent } from 'react'

import { Icon, IconComponent, PackageSelect } from '@graftcode/design-system'

import { CardInstallation } from '../CardInstallation'

import { useInstallationCardDock } from './hooks/useInstallationCardDock'

import styles from './DesktopCardView.module.scss'

type InstallationSectionProps = ComponentProps<typeof CardInstallation>

export function InstallationSection({
  installationCardKey,
  technologies,
  suggestedTechnologies,
  selectedTechnology,
  onTechnologyChange,
  ...cardInstallationProps
}: InstallationSectionProps) {
  const { installationRef, showDock, scrollToInstallation } = useInstallationCardDock(installationCardKey)

  const stopDockSelectPropagation = (event: MouseEvent<HTMLDivElement>) => {
    event.stopPropagation()
  }

  return (
    <>
      <div ref={installationRef} className={styles.installationInFlow}>
        <CardInstallation
          installationCardKey={installationCardKey}
          technologies={technologies}
          suggestedTechnologies={suggestedTechnologies}
          selectedTechnology={selectedTechnology}
          onTechnologyChange={onTechnologyChange}
          {...cardInstallationProps}
        />
      </div>

      {showDock && (
        <div className={styles.installationDock}>
          <div className={styles.installationDockBar}>
            <button
              type="button"
              className={styles.installationDockScroll}
              onClick={scrollToInstallation}
              aria-label="Scroll to installation"
            >
              <IconComponent className={styles.installationDockIcon} icon={Icon.DSTerminal} size={24} />
              <span className={styles.installationDockLabel}>Installation</span>
              <IconComponent
                className={styles.installationDockChevron}
                icon={Icon.ChevronUpRegular}
                size={20}
                aria-hidden
              />
            </button>

            <div
              className={`${styles.installationDockSelect} installation-card__header`}
              onClick={stopDockSelectPropagation}
              onPointerDown={stopDockSelectPropagation}
            >
              <PackageSelect
                technologies={technologies}
                suggestedTechnologies={suggestedTechnologies}
                selectedTechnology={selectedTechnology}
                onTechnologyChange={onTechnologyChange}
              />
            </div>
          </div>
        </div>
      )}
    </>
  )
}
